// === frontend/src/components/Header.js ===
// (MODIFIED - Display plan status more clearly, link dashboard always if logged in)
import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import "./Header.css";
import mixpanel from "mixpanel-browser";
import { trackEvent } from "../utils/mixpanel";

function Header() {
  const { user, handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false); // Close menu on navigation
  }, [location]);

  const onLogoutClick = () => {
    trackEvent("Logged Out");
    handleLogout();
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="main-header">
      <div className="container">
        <nav>
          <Link to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
            {" "}
            {/* Close menu on logo click */}
            Grandmaster AI
          </Link>

          <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            <Link to="/#features">Features</Link>
            <Link to="/chrome-extension">ChromeExtension</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/#about">About</Link>
            {/* Add Dashboard link here if user is logged in */}
            {user && <Link to="/dashboard">Dashboard</Link>}
          </div>

          <div id="auth-section">
            {user ? (
              <>
                <span className="user-info">
                  <Link to="/dashboard" className="username-link">
                    {user.lichess_username}
                  </Link>
                  <span className={`plan-indicator ${user.plan}`}>
                    {user.plan === PlanEnum.premium ? "Premium" : "Free"}
                  </span>
                </span>
                <button onClick={onLogoutClick} className="logout-button">
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                id="login-link"
                className="login-button"
                onClick={() => trackEvent("Login Link Clicked")}
              >
                Login
              </Link>
            )}
            <button
              className={`menu-toggle ${isMenuOpen ? "open" : ""}`} // Add 'open' class for X animation
              onClick={toggleMenu}
              aria-label="Toggle navigation"
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}

// Define PlanEnum locally or import if shared
const PlanEnum = {
  free: "free",
  premium: "premium",
};

export default Header;
